import { type ServiceConfig } from '../../ServiceRegistry';
import { FinancialAssetsExposureService } from '@/services/dashboard/FinancialAssetsExposureService';
import { ObligationScheduleSubmissionsService } from '@/services/dashboard/ObligationScheduleSubmissionsService';
import { ChartQueryService } from '@/services/dashboard/ChartQueryService';
import { AviationDashboardService } from '@/services/dashboard/AviationDashboardService';
import { MarineDashboardService } from '@/services/dashboard/MarineDashboardService';
import { RailDashboardService } from '@/services/dashboard/RailDashboardService';
import { SmeDashboardService } from '@/services/dashboard/SmeDashboardService';
import { NonUsResiDashboardService } from '@/services/dashboard/NonUsResiDashboardService';
import { NonUsCreDashboardService } from '@/services/dashboard/NonUsCreDashboardService';
import { TripleNetLeaseDashboardService } from '@/services/dashboard/TripleNetLeaseDashboardService';
import { ReportingObligationsService } from '@/services/dashboard/ReportingObligationsService';
import { DataValidationSummaryService } from '@/services/dashboard/DataValidationSummaryService';
import { PrivateCreditFinanceDashboardService } from '@/services/dashboard/PrivateCreditFinanceDashboardService';
import { StudentLoanDashboardService } from '@/services/dashboard/StudentLoanDashboardService';
import { FundFinanceDashboardService } from '@/services/dashboard/FundFinanceDashboardService';
import { ExposureService } from '@/services/dashboard/ExposureService';
import { SsrmGatewayService } from '@/services/dashboard/SsrmGatewayService';
import { FacilityPerformanceService } from '@/services/dashboard/FacilityPerformanceService';
import { AtlasMappingsService } from '@/services/dashboard/AtlasMappingsService';
import { MasterTapeMappingsService } from '@/services/dashboard/MasterTapeMappingsService';
import { TriggersAndCovenantsService } from '@/services/dashboard/TriggersAndCovenantsService';
import { ClsDashboardService } from '@/services/dashboard/ClsDashboardService';
import { AnalyticsEmailService } from '@/services/dashboard/AnalyticsEmailService';

/**
 * AGA Dashboard federated module — registers dashboard facades on the host registry.
 */
export const dashboardServices: ServiceConfig[] = [
  {
    name: 'financialAssetsExposureService',
    factory: () => new FinancialAssetsExposureService(),
  },
  {
    name: 'obligationScheduleSubmissionsService',
    factory: () => new ObligationScheduleSubmissionsService(),
  },
  {
    name: 'chartQueryService',
    factory: () => new ChartQueryService(),
  },
  {
    name: 'aviationDashboardService',
    factory: () => new AviationDashboardService(),
  },
  {
    name: 'marineDashboardService',
    factory: () => new MarineDashboardService(),
  },
  {
    name: 'railDashboardService',
    factory: () => new RailDashboardService(),
  },
  {
    name: 'smeDashboardService',
    factory: () => new SmeDashboardService(),
  },
  {
    name: 'nonUsResiDashboardService',
    factory: () => new NonUsResiDashboardService(),
  },
  {
    name: 'nonUsCreDashboardService',
    factory: () => new NonUsCreDashboardService(),
  },
  {
    name: 'tripleNetLeaseDashboardService',
    factory: () => new TripleNetLeaseDashboardService(),
  },
  {
    name: 'reportingObligationsService',
    factory: () => new ReportingObligationsService(),
  },
  {
    name: 'dataValidationSummaryService',
    factory: () => new DataValidationSummaryService(),
  },
  {
    name: 'privateCreditFinanceDashboardService',
    factory: () => new PrivateCreditFinanceDashboardService(),
  },
  {
    name: 'studentLoanDashboardService',
    factory: () => new StudentLoanDashboardService(),
  },
  {
    name: 'fundFinanceDashboardService',
    factory: () => new FundFinanceDashboardService(),
  },
  {
    name: 'exposureService',
    factory: () => new ExposureService(),
  },
  {
    name: 'ssrmGatewayService',
    factory: () => new SsrmGatewayService(),
  },
  {
    name: 'facilityPerformanceService',
    factory: () => new FacilityPerformanceService(),
  },
  {
    name: 'atlasMappingsService',
    factory: () => new AtlasMappingsService(),
  },
  {
    name: 'masterTapeMappingsService',
    factory: () => new MasterTapeMappingsService(),
  },
  {
    name: 'triggersAndCovenantsService',
    factory: () => new TriggersAndCovenantsService(),
  },
  {
    name: 'clsDashboardService',
    factory: () => new ClsDashboardService(),
  },
  {
    name: 'analyticsEmailService',
    factory: () => new AnalyticsEmailService(),
  },
];

export const dashboardServiceUtils = {
  getServiceNames: () => dashboardServices.map(s => s.name),
  isDashboardService: (name: string) => dashboardServices.some(s => s.name === name),
  getBasePath: () => '/asset-class-dashboard',
};
